module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/campaign-bd872737d50e28d45f0b243227f4c914.png";